/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';

import AppPropTypes from 'proptypes/AppPropTypes';
import withLocale from 'components/withLocale/withLocale';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // componentDidCatch(error, errorInfo) {
  //   // You can also log the error to an error reporting service
  //   logErrorToMyService(error, errorInfo);
  // }

  render() {
    const { locale } = this.props;
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <h1 data-qa="error-boundary">{this.props.msg || locale['common.somethingWentWrong']}</h1>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  msg: PropTypes.string,
  locale: AppPropTypes.locale.isRequired
};

ErrorBoundary.defaultProps = {
  msg: ''
};

export default withLocale(ErrorBoundary);
